module.exports = __webpack_public_path__ + "static/media/checklist-icon-active.777d4d41.svg";